{
  "version": 1,
  "asset_id": "2125d462-87d3-4a23-b09b-0816b6be78a8",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/2125d462-87d3-4a23-b09b-0816b6be78a8/stappenplan-aanleg-1280.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/2125d462-87d3-4a23-b09b-0816b6be78a8/stappenplan-aanleg-1280.avif",
  "original_filename": "stappenplan-aanleg-1280.avif",
  "size": 75312,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:05:36Z"
}
